module.exports = __webpack_public_path__ + "static/bedroom-699ee7c4a7c0063319ea28631480e373.jpg";